import toggleFlashlight from 'app/_shared/events/camera/toggleFlashlight'
import processScannedCode from 'app/xEcoCamera/event/processScannedCode'

export default {
  onClick: {
    toggleFlashlight,
  },
  onScan: {
    processScannedCode,
  },
}
